import { Alert } from "@mui/material";

interface LoadingSpinnerProps {
  message?: string;
  error?: string;
}

export const LoadingSpinner = ({ message = "Loading...", error = "" }: LoadingSpinnerProps) => 
  error 
    ? (<Alert severity="error">{error}</Alert>)
    : (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto mb-4"></div>
          <p>{message}</p>
        </div>
      </div>
);